
import type { CustomerApi, CustomersDashboardApi } from "@/types/api/customers";
import type { CustomerUI, CustomersKpisUI } from "@/types/ui/customers";

export function mapCustomerApiToUi(apiCustomer: CustomerApi): CustomerUI {
  return {
    id: apiCustomer.id,
    name: apiCustomer.name,
    accountNumber: apiCustomer.accountNumber,
    currency: apiCustomer.currency as "USD" | "EUR" | "GBP" | "CAD" | "AUD",
    outstanding: apiCustomer.outstanding,
    overdue: apiCustomer.overdue,
    creditLimit: apiCustomer.creditLimit,
    dso: apiCustomer.dso ?? 0,
    risk: apiCustomer.risk,
    lastPayment: apiCustomer.lastPayment ?? "",
    contact: apiCustomer.contact ?? "",
    phone: apiCustomer.phone ?? "",
    address: "",
    paymentTerms: "Net 30",
    collectionStrategyId: "",
  };
}

export function mapDashboardToKpis(dashboard: CustomersDashboardApi): CustomersKpisUI {
  return {
    totalCustomers: dashboard.totalCustomers,
    totalOutstanding: dashboard.totalOutstanding,
    totalOverdue: dashboard.totalOverdue,
    highRiskCount: dashboard.highRiskCount,
  };
}
